import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35d69d31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { href: "https://getindya.com/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "login" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "inline sm:hidden" }
const _hoisted_9 = { class: "hidden sm:inline" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "box-content"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box" }, "inicia sesión", -1))
const _hoisted_15 = { class: "content" }
const _hoisted_16 = {
  key: 0,
  class: "header-subscribe"
}
const _hoisted_17 = { class: "header-subscribe-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header-desktop" }, [
  /*#__PURE__*/_createTextVNode("No es dieta,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" es deporte.")
], -1))
const _hoisted_19 = { class: "header-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "left", {}, undefined, true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/images/logo.svg'),
            alt: "logo",
            class: "h-5"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Login, {
                class: _normalizeClass(["login-box", { opened: _ctx.opened }])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "box",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.opened = !_ctx.opened), ["prevent"]))
                  }, [
                    _createElementVNode("span", null, [
                      _createTextVNode(" ¡Hola "),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.short(_ctx.user.name)), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.name), 1),
                      _createTextVNode("! ")
                    ]),
                    _createElementVNode("img", {
                      src: require('@/assets/images/chevron.svg'),
                      alt: "open"
                    }, null, 8, _hoisted_10)
                  ]),
                  (_ctx.opened)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createTextVNode(" ¿No eres " + _toDisplayString(_ctx.user.name) + "? ", 1),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, "Sign out")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : (_ctx.isPromo())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_Login, {
                  class: "login-box",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.HEADER_TITLE_1), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.HEADER_TITLE_2), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}